export const getOrgAndCaseId = (search: string) => {
  const queryParams = new URLSearchParams(search);
  const filteredParams = new URLSearchParams();
  if (queryParams.has('orgId')) {
    filteredParams.set('orgId', queryParams.get('orgId')!);
  }
  if (queryParams.has('caseId')) {
    filteredParams.set('caseId', queryParams.get('caseId')!);
  }
  const filteredSearch = filteredParams.toString() ? `?${filteredParams}` : '';
  return filteredSearch;
};
